<div class="otp-card {{ admin ? 'admin-otp' : ''}}">
  <!-- Digit inputs -->
  <div class="otp-inputs" role="group">
    <input
      *ngFor="let digit of digits; let i = index; trackBy: trackByIndex"
      #otpBox
      type="text"
      inputmode="numeric"
      [value]="digit"
      pattern="[0-9]*"
      maxlength="1"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      [attr.id]="'otp-digit-' + i"
      [attr.name]="'otp-digit-' + i"
      [attr.aria-label]="'number ' + (i + 1)"
      [class.filled]="digit !== ''"
      [class.shake]="shakeTrigger"
      class="otp-box"
      (input)="handleInput($event, i)"
      (keydown)="handleKeydown($event, i)"
      (paste)="handlePaste($event)"
      (focus)="handleFocus($event)"
      
    />
  </div>


</div>